<template>
 <nav role="navigation">
  <div class="page">
    <!--  kanske nedan kan ersättas med -> div class="navbar-inner" OCH kolla currentRoutei router städa path-->
    <div :class="{'navbar-inner': currentRoute.path === '/'}">
      <div class="navbar-container">
        <div class="hem">
          <a class="router-link home-button header-button primary" :href="frontendUrl" aria-label="Hem, till startsidan för Stå kvar i Bolagsverkets register">
            <img class="hemikon" :src="require('@/../public/images/home_white.svg')" alt="" />
            <span class="hemtext">{{ $t("hem") }}</span>
          </a>
        </div>
        </div>
      </div>
    </div>
 </nav>
</template>

<script setup lang="ts">
import { RouteLocationNormalizedLoaded, useRouter } from "vue-router";
import { ref, watch } from "vue";
const router = useRouter();

const frontendUrl = ref<string>(process.env.VUE_APP_FRONTEND_URL);
const currentRoute = ref<RouteLocationNormalizedLoaded>(router.currentRoute.value);

watch(
  () => router.currentRoute.value,
  (to: RouteLocationNormalizedLoaded) => {
    currentRoute.value = to;
  }
);

</script>

<style lang="scss" scoped>
.navbar {
	background: $color-darkblue-bv;
  text-align: center;
}
.navbar-inner {
  margin: 0 auto;
}
.navbar-container {
  overflow: hidden;
  display:flex;
}
.router-link {
  cursor: pointer;
}
nav {
  background-color: #002857;
  color: #fff;
  bottom: 0;
  padding: 1em;
}
.nav-element {
  display: inline-block;
  padding: 0.5em 2em;
  margin: 0 0.2;
  margin-top: 0.8em; 
  color: #fff;
  font-weight: bold;
}
.nav-element:hover {
  text-decoration: underline;
  cursor: pointer;
}
.active {
  background: #1979e7;
}
.nav-element:hover{
  text-decoration: underline;
}
.hem {
  color: $color-white;
  padding: 0.5em;
}
.hemtext{
  font-weight: 700;
  margin-left: 0.3rem;
  margin-top: 0.3em;
}
.header-button {
  background: none;
  z-index: 1;
  text-decoration: none;
  display: flex;
  align-items: center;
  width: fit-content;
}
.header-button > span {
  font-weight: bold;
}
.header-button:hover {
  cursor: pointer;
}
.header-button:hover:after {
  height: 100%;
}
.header-button:focus {
  outline:solid;
  outline-color: #fecb00;
  outline-offset: 1px;
  outline-width: 2px;
}
.hemikon {
  height: 2.1em;
}
</style>
